import React from 'react';

import useStyles from './useStyles';

export type Props = {
  children: React.ReactNode;
  maxQuestionsPerRow?: number;
  isOQAAT?: boolean;
};

function QuestionRowLayout({ children, maxQuestionsPerRow = 4, isOQAAT = true }: Props): React.ReactElement {
  const numOfQuestions = React.Children.count(children);
  const { gridItem, gridRow } = useStyles({
    numOfQuestions,
    maxQuestionsPerRow,
  });

  if (isOQAAT) {
    return <>{children}</>;
  }

  return (
    <div className={gridRow}>
      {React.Children.map(children, child => (
        <div className={gridItem}>{child}</div>
      ))}
    </div>
  );
}

export default QuestionRowLayout;
